import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { autorun, reaction } from 'mobx';
import cx from 'classnames';
import { v4 as uuidv4 } from 'uuid';
import $ from 'jquery';
import {
  Dimmer, Segment, Loader, Label, Icon, Pagination, Input, Modal
} from 'semantic-ui-react';
import { Scrollbars } from 'react-custom-scrollbars-2';
import { withTranslation } from 'react-i18next';
import ContentsHeaderWithResultAll from '../SubHeader/ContentsHeaderWithResultAll';
import api from '../../api';
import PieChart from '../Extensions/PieChart2';
import Footer from '../Footer/Footer';
import closeBtn from '../../images/components/content_wide_card/closeBtn.png';
import expandBtn from '../../images/components/content_file/expand-btn.svg';
import downIcon from '../../images/components/content_wide_card/headerSorting (down).png';
import upIcon from '../../images/components/content_wide_card/headerSorting (up).png';
import ComponentVersionModal from '../Modal/ComponentVersionModal';
import WithRouter from '../Extensions/WithRouter';
import ComponentRow from './ComponentRow';
import EditComponentModal from '../Modal/EditComponentModal';
import compareBtn from '../../images/icons/compare.png';
import FeedModal from '../Modal/FeedModal';
import TextWithEllipsis from '../Extensions/TextWithEllipsis';

class ComponentDetail extends Component {
  constructor(props) {
    super(props);
    const { state, params } = this.props;
    this.modalAction = null;
    this.modalBody = null;
    this.smallBody = null;
    this.viewRef = React.createRef();
    this.componentDetail = React.createRef();
    this.state = {
      pageSize: state.user.page_limit,
      currentPage: 1,
      totalPage: '',
      viewMode: state.user.view_mode,
      error: null,
      isLoading: false,
      isDetailLoading: false,
      isVisible: '',
      hasMore: false,
      componentFileList: [],
      activeIndex: [],
      sortValue: '3',
      isSort: false,
      searchKeyword: '',
      filter: [],
      idReport: params.idReport,
      infoPopupIndex: [],
      popupType: '',
      isOpenCVM: false,
      componentName: null,
      currentComponentVersion: null,
      componentVersionType: 'detail',
      activePage: '',
      pdfElement: '',
      isRenderListOnly: false,
      isOpenWarnModal: false,
      isLoaderMEC: false,
      isOpenMEC: false,
      componentList: [],
      sumData: {},
      customComponent: null,
      updateComponentObject: {
        isUpdate: false,
        ufid: '',
        component_name: ''
      },
      totalCount: 0,
      isOpenMFD: false,
      currentComponentName: '',
      commentList: [],
    };
  }

  componentDidMount() {
    const { state } = this.props;
    window.addEventListener('scroll', this.handleOnScroll);
    this.setupFixedHeaders();

    this.disposeUserReaction = autorun(() => {
      this.setState({
        viewMode: state.user.view_mode,
        pageSize: state.user.page_limit,
      });
    });

    this.disposeComponentKeywordReaction = reaction(
      () => { return state.report.componentKeyword; },
      (componentKeyword) => {
        if (componentKeyword !== 0) {
          this.updateDefinedFilter(componentKeyword);
        }
      },
      {
        fireImmediately: true
      }
    );

    this.disposeComponentFileListReaction = reaction(
      () => { return state.user.currentPrecisionLevel; },
      (currentPrecisionLevel) => {
        if (currentPrecisionLevel !== null && this.componentDetail) {
          this.getComponentfileList();
        }
      },
      {
        fireImmediately: true
      }
    );

    window.scrollTo(0, 0);
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  componentDidUpdate(prevProps) {
    const { params, state } = this.props;

    if (prevProps.params.idReport !== params.idReport && !state.report.isActiveNav) {
      this.resetStateForNewReport(params.idReport);
    }
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleOnScroll);
    document.removeEventListener('mousedown', this.handleClickOutside);
    $(window).off('scroll.contents_header');
    $(document).off('mouseover');

    if (this.disposeUserReaction) {
      this.disposeUserReaction();
    }
    if (this.disposeComponentKeywordReaction) {
      this.disposeComponentKeywordReaction();
    }
    if (this.disposeComponentFileListReaction) {
      this.disposeComponentFileListReaction();
    }
  }

  handleSaveCallback = (sumData) => {
    const { t } = this.props;
    const {
      uploaded_file_id,
      component_name,
      is_applied,
      coverage,
    } = sumData;

    this.modalAction = t('modal.title.notice');
    if (!is_applied) {
      this.modalBody = t('modal.message.save_is_not_apply_next_scan');
      this.smallBody = null;
    }

    if (is_applied && coverage) {
      if (coverage === 'project') {
        this.modalBody = t('modal.message.save_is_apply_next_scan_project');
        this.smallBody = t('modal.message.save_is_apply_next_scan_project_sub');
      }
      if (coverage === 'company') {
        this.modalBody = t('modal.message.save_is_apply_next_scan_project');
        this.smallBody = t('modal.message.save_is_apply_all_scan');
      }
    }

    this.setState({
      isOpenMEC: false,
      isOpenWarnModal: true,
      componentList: [],
      sumData: {},
    }, () => {
      this.updateComponentFileList(uploaded_file_id, component_name);
    });
  };

  handleActivePageChange = (e) => {
    const { totalPage, pageSize, activePage } = this.state;
    if (e.key === 'Enter') {
      if (activePage > totalPage) {
        return;
      }
      this.setState({
        componentFileList: [],
        activeIndex: [],
        currentPage: activePage,
      }, () => {
        this.getComponentfileList(activePage, pageSize);
      });
    }
  };

  handleInputActivePageChange = (e, { value }) => {
    const { totalPage } = this.state;
    if (totalPage < value) {
      return;
    }

    this.setState({
      activePage: value,
    });
  };

  handleOnScroll = () => {
    const {
      getComponentfileList,
      state: {
        error, isLoading, hasMore, viewMode, currentPage
      },
    } = this;
    if (viewMode === 'list') {
      return;
    }
    const scrollHeight = Math.max(
      document.documentElement.scrollHeight,
      document.body.scrollHeight
    );
    const scrollTop = Math.max(document.documentElement.scrollTop, document.body.scrollTop);
    const { clientHeight } = document.documentElement;
    if (error || isLoading || !hasMore) {
      return;
    }
    if (scrollTop + clientHeight >= scrollHeight) {
      getComponentfileList(currentPage + 1);
    }
  };

  handleChange = (value) => {
    this.setState(
      {
        searchKeyword: value,
        componentFileList: [],
        activeIndex: [],
      },
      () => {
        this.getComponentfileList();
      }
    );
  };

  handleFilterData = (value) => {
    this.setState(
      {
        componentFileList: [],
        activeIndex: [],
        filter: value.filter,
      },
      () => {
        this.getComponentfileList();
      }
    );
  };

  handleCompareAllVersion = (componentName) => {
    const { componentFileList } = this.state;

    const selectedIndex = componentFileList.findIndex((item) => {
      return item.componentName === componentName;
    });

    this.setState({
      isOpenCVM: true,
      componentName,
      currentComponentVersion: Object.keys(componentFileList[selectedIndex].componentList.components)[0],
    });
  };

  handleCVMClose = () => {
    this.setState({
      isOpenCVM: false,
    });
  };

  handleMoreInfo = (index, value) => {
    const { infoPopupIndex } = this.state;
    let newState;

    if (infoPopupIndex.indexOf(index) === -1) {
      newState = [...infoPopupIndex, index];
    } else {
      newState = infoPopupIndex;
    }

    this.setState({
      infoPopupIndex: newState,
      popupType: value,
    });
  };

  handleMoreInfoClose = (index) => {
    const { infoPopupIndex } = this.state;
    const newState = infoPopupIndex.filter((i) => {
      return i !== index;
    });

    this.setState({
      infoPopupIndex: newState,
      popupType: '',
    });
  };

  handleClickOutside = (event) => {
    const { infoPopupIndex, popupType } = this.state;
    const container = $('.card_detail_popup .popup_box');
    if (container && container.has(event.target).length === 0) {
      if (infoPopupIndex.length !== 0 && popupType !== '') {
        return this.setState({
          infoPopupIndex: [],
          popupType: '',
        });
      }
    }
  };

  handlePageSizeChange = (value) => {
    this.setState(
      {
        pageSize: value,
        currentPage: 1,
        componentFileList: [],
        activeIndex: [],
      },
      () => {
        this.getComponentfileList();
      }
    );
  };

  handlePaginationChange = (e, { activePage }) => {
    const { pageSize } = this.state;
    this.setState({
      componentFileList: [],
      activeIndex: [],
      currentPage: activePage,
      activePage,
    }, () => {
      this.getComponentfileList(activePage, pageSize);
    });
  };

  handleMECClose = () => {
    this.setState({
      isOpenMEC: false,
      componentList: [],
      sumData: {},
    });
  };

  handleModalLoader = (value) => {
    this.setState({
      isLoaderMEC: value,
    });
  };

  handleSearchChange = (value) => {
    this.setState({
      searchKeyword: value,
    });
  };

  handleMFDOpen = (name, list) => {
    this.setState({
      isOpenMFD: true,
      currentComponentName: name,
      commentList: list,
    });
  };

  getComponentEdit = (uid, component_name) => {
    const { state, t } = this.props;
    let type;

    if (state.user.currentPrecisionLevel) {
      type = state.user.currentPrecisionLevel;
    } else {
      type = null;
    }

    const obj = {
      component_name,
      precision_level: type,
    };

    this.setState({
      isLoaderMEC: true,
      isOpenMEC: true,
    });

    api
      .getComponentEdit(uid, obj)
      .then((response) => {
        const data = response.response;
        const customIds = [];
        const versionList = [{
          key: 'all', text: t('settings.list.all_versions'), value: 'all',
        }];

        while (customIds.length < data.components.length) {
          const r = uuidv4();
          customIds.push(r);
        }

        const componentList = data.components.map((row, index) => {
          const newVersion = {
            key: row.component_version, text: row.component_version, value: row.component_version,
          };
          versionList.push(newVersion);
          return {
            id: customIds[index],
            component_name: row.component_name,
            component_version: row.component_version,
            securities: row.securities,
            title_license: row.title_license,
            homepage: row.homepage,
          };
        });

        const sumData = {
          component_name: data.component_name,
          component_version: data.component_version,
          uploaded_file_id: data.uploaded_file_id,
          project_id: data.project_id,
          project_version_id: data.project_version_id,
          project_name: data.project_name,
          project_version_name: data.project_version_name,
          is_applied: data.is_applied,
          has_global_permission: data.has_global_permission,
          coverage: data.coverage || '',
          comment: data.comment || '',
          versionList,
        };

        this.setState({
          isLoaderMEC: false,
          componentList,
          sumData,
        });

      })
      .catch((err) => {
        console.error(err);
        this.setState({
          isLoaderMEC: false,
        });
      });
  };

  setupFixedHeaders = () => {
    const $window = $(window);
    const headers = $('.contents_header, .table_header');
    $window.on('scroll.contents_header', () => {
      headers.toggleClass('fixed', $window.scrollTop() > 140);
    });
  };

  closeModal = () => {
    this.modalBody = null;
    this.smallBody = null;
    this.setState({
      isOpenWarnModal: false,
    });
  };

  closeMFDModal = (list) => {
    const { commentList } = this.state;
    this.setState({
      isOpenMFD: false,
    });
    if (list !== 0 && (commentList.length !== list.length)) {
      this.updateCommentList(list);
    }
  };

  updateCommentList = (newComments) => {
    const { currentComponentName, componentFileList } = this.state;

    const updatedList = componentFileList.map((file) => {
      if (file.componentName === currentComponentName) {
        return {
          ...file,
          componentList: {
            ...file.componentList,
            more_info: {
              ...file.componentList.more_info,
              comment: newComments
            }
          }
        };
      }
      return file;
    });

    this.setState({ componentFileList: updatedList });
  };

  toggleViewMode = (value) => {
    this.setState({
      viewMode: value,
      currentPage: 1,
      searchKeyword: '',
      componentFileList: [],
      activeIndex: [],
    }, () => {
      this.getComponentfileList();
    });
  };

  onChangeSorting = (e) => {
    const { isSort, sortValue } = this.state;
    if (e.currentTarget.dataset.id !== sortValue) {
      this.setState(
        {
          sortValue: e.currentTarget.dataset.id,
          isSort: false,
          componentFileList: [],
          activeIndex: [],
        },
        () => {
          this.getComponentfileList();
        }
      );
    } else {
      this.setState(
        {
          sortValue: e.currentTarget.dataset.id,
          isSort: !isSort,
          componentFileList: [],
          activeIndex: [],
        },
        () => {
          this.getComponentfileList();
        }
      );
    }
  };

  setPrecisionLevel = (value) => {
    const { state } = this.props;
    this.setState({
      componentFileList: [],
      activeIndex: [],
    }, () => {
      state.user.setPrecisionLevel(value);
    });
  };

  updateComponentFileList = (ufid, component_name) => {
    this.setState({
      currentPage: 1,
      componentFileList: [],
      updateComponentObject: {
        isUpdate: true,
        ufid,
        component_name,
      }
    }, () => {
      this.getComponentfileList();
    });
  };

  getComponentfileList = (pageNo, limit) => {
    const {
      isSort,
      sortValue,
      componentFileList,
      pageSize,
      updateComponentObject,
      idReport,
      searchKeyword,
      customComponent,
      filter,
    } = this.state;
    const { state, t, navigate } = this.props;

    const page = pageNo || 1;
    const perPage = limit || pageSize || state.user.page_limit || localStorage.getItem('page_limit');
    const precisionLevel = state.user.currentPrecisionLevel || null;
    const filterData = filter.length ? filter.join(',') : '';

    const sortOrderMappings = {
      1: isSort ? 'component_name' : 'component_name_r',
      2: isSort ? 'component_version_count_r' : 'component_version_count',
      3: isSort ? 'scanned_file_count_r' : 'scanned_file_count',
      4: isSort ? 'security_count_r' : 'security_count',
      5: isSort ? 'license_count_r' : 'license_count',
      6: isSort ? 'title_license' : 'title_license_r',
      7: isSort ? 'litigator_count_r' : 'litigator_count',
    };

    const orderText = sortOrderMappings[sortValue] || 'scanned_file_count';

    const data = {
      search: searchKeyword,
      filter: filterData,
      page,
      limit: perPage,
      order: orderText,
      precision_level: precisionLevel,
    };

    if (customComponent) {
      data.custom_apply = { component: customComponent };
    }

    this.setState({ isLoading: true }, () => {
      api.getComponentfileList(data, idReport)
        .then((response) => {
          if (componentFileList.length !== 0 && response.pagination.current === 1) {
            return false;
          }
          const nextComponentFileList = response.response.map((item) => {
            return {
              uploadedFileId: item.uploaded_file_id,
              componentName: item.component_name,
              componentVersionCount: item.component_version_count,
              scannedFileCount: item.scanned_file_count,
              securityCount: item.security_count,
              licenseCount: item.license_count,
              titleLicense: item.title_license,
              litigatorString: item.litigator_string,
              hasExploit: item.has_exploit,
            };
          });

          this.setState({
            currentPage: response.pagination.current,
            pageSize: response.pagination.per_page,
            totalPage: response.pagination.pages,
            totalCount: response.pagination.count,
            hasMore: response.pagination.next !== null,
            isLoading: false,
            componentFileList: [...componentFileList, ...nextComponentFileList],
          });

          if (updateComponentObject.isUpdate) {
            const componentData = [...componentFileList, ...nextComponentFileList];
            const updateIndex = componentData.findIndex((item) => { return item.componentName === updateComponentObject.component_name; });

            if (componentData.length === 0) {
              return navigate('/results/overview');
            }

            if (updateIndex !== -1) {
              const { componentName } = componentData[updateIndex];
              this.setState({
                activeIndex: [updateIndex],
              });
              this.getComponentFileDetail(idReport, componentName);
              state.user.setUpdateComponentSummaryValue(true);
            } else {
              this.setState({
                activeIndex: [],
              });
              state.user.setUpdateComponentSummaryValue(true);
            }
          }
        })
        .catch((err) => {
          console.log(err);
          this.setState({
            error: t('modal.error.error_load'),
            isLoading: false,
          });
        });
    });
  };

  getComponentFileDetail = (ufid, componentName) => {
    const { state, t } = this.props;
    const precisionLevel = state.user.currentPrecisionLevel || null;

    this.setState({
      isDetailLoading: true,
      isVisible: componentName,
    }, () => {
      api.getComponentFileDetail({
        component_name: componentName,
        precision_level: precisionLevel,
      }, ufid)
        .then((response) => {
          const { componentFileList } = this.state;
          const updatedIndex = componentFileList.findIndex((item) => { return item.componentName === componentName; });

          if (updatedIndex !== -1) {
            const newData = [...componentFileList];
            newData[updatedIndex] = {
              ...newData[updatedIndex],
              componentList: response.response,
            };

            this.setState({
              componentFileList: newData,
              isDetailLoading: false,
              isVisible: '',
              updateComponentObject: {
                isUpdate: false,
                ufid: '',
                component_name: '',
              },
            });
          }
        })
        .catch((err) => {
          console.error(err);
          this.setState({
            error: t('modal.error.error_load'),
            isDetailLoading: false,
            isVisible: '',
          });
        });
    });
  };

  createElementWithCanvas = () => {
    const { t } = this.props;

    //pdfElement
    const contentElem = document.querySelector('.content');
    if (contentElem) {
      const wrapper = contentElem.closest('.container');
      const clonedObject = wrapper.cloneNode(true);
      const containerEl = clonedObject.closest('.container');
      containerEl.style.paddingTop = 0;

      if (clonedObject) {
        const resultHeaderEl = clonedObject.getElementsByClassName('result_header');
        const resultHeaderInnerEl = clonedObject.getElementsByClassName('result_header_inner');
        const contentsSummaryInnerEl = clonedObject.getElementsByClassName('contents_summary_inner');
        const contentsEl = clonedObject.getElementsByClassName('contents');
        const utilWrapEl = clonedObject.getElementsByClassName('util_wrap');
        const moveTopEl = clonedObject.getElementsByClassName('move_to_top');
        const pageEle = clonedObject.getElementsByClassName('clar_pagination');
        const footerEl = clonedObject.getElementsByClassName('footer');
        const tableEl = clonedObject.getElementsByClassName('wide_card_box');
        const expandTableEl = clonedObject.getElementsByClassName('wide_card_box expand');

        this.modalAction = t('modal.title.attention');

        if (expandTableEl.length !== 0) {
          this.modalBody = t('modal.message.clraity_report_main_warn');
          this.smallBody = t('modal.message.clarity_reporty_sub_warn');
          return this.setState({
            isOpenWarnModal: true,
          });
        }

        if (resultHeaderEl.length !== 0) {
          resultHeaderEl[0].style.top = 0;
        }

        if (resultHeaderInnerEl.length !== 0) {
          resultHeaderInnerEl[0].style.setProperty('padding-left', '0', 'important');
        }

        if (contentsSummaryInnerEl.length !== 0) {
          contentsSummaryInnerEl[0].style.setProperty('padding-left', '0', 'important');
        }

        if (contentsEl.length !== 0) {
          contentsEl[0].style.setProperty('padding-left', '0', 'important');
        }

        if (utilWrapEl.length !== 0) {
          while (utilWrapEl.length > 0) {
            utilWrapEl[0].parentNode.removeChild(utilWrapEl[0]);
          }
        }

        if (moveTopEl.length !== 0) {
          while (moveTopEl.length > 0) {
            moveTopEl[0].parentNode.removeChild(moveTopEl[0]);
          }
        }

        if (pageEle.length !== 0) {
          while (pageEle.length > 0) {
            pageEle[0].parentNode.removeChild(pageEle[0]);
          }
        }

        if (footerEl.length !== 0) {
          while (footerEl.length > 0) {
            footerEl[0].parentNode.removeChild(footerEl[0]);
          }
        }

        //wide_card_box wide_card_type_01
        if (tableEl.length > 16) {
          let i = 0;
          for (i; i < tableEl.length; i++) {
            if ((i === 15 && tableEl.length > 16) || (i > 15 && (i - 15) % 18 === 0)) {
              tableEl[i].classList.add('page-break');
            }
          }
        }
      }

      document.body.appendChild(clonedObject);

      this.setState({
        pdfElement: clonedObject,
        isRenderListOnly: true,
      });
    }
  };

  generatePdfCallback = () => {
    const { pdfElement } = this.state;

    document.body.removeChild(pdfElement);
    this.setState({
      pdfElement: '',
      isRenderListOnly: false,
    });
  };

  toggleRow = (index, componentName) => {
    const { activeIndex, idReport } = this.state;
    let newState;

    if (activeIndex.indexOf(index) > -1) {
      newState = activeIndex.filter((i) => {
        return i !== index;
      });
    } else {
      this.getComponentFileDetail(idReport, componentName, index);
      newState = [...activeIndex, index];
    }
    this.setState({
      activeIndex: newState,
    });
  };

  clearValue = (tagValue) => {
    const { filter } = this.state;
    let newState;
    if (filter.indexOf(tagValue) > -1) {
      newState = filter.filter((el) => {
        return el !== tagValue;
      });
    } else {
      newState = [];
    }
    this.setState(
      {
        componentFileList: [],
        activeIndex: [],
        filter: newState,
      },
      () => {
        this.getComponentfileList();
      }
    );
  };

  clearAllValue = () => {
    const { state } = this.props;
    this.setState(
      {
        searchKeyword: '',
        componentFileList: [],
        activeIndex: [],
        filter: [],
      },
      () => {
        this.getComponentfileList();
        state.report.initSearchKeyword();
      }
    );
  };

  resetStateForNewReport = (idReport) => {
    this.setState({
      idReport,
      searchKeyword: '',
      componentFileList: [],
      activeIndex: [],
      filter: [],
      customComponent: null,
      updateComponentObject: {
        isUpdate: false,
        ufid: '',
        component_name: ''
      }
    }, this.getComponentfileList);
  };

  clearSearch = () => {
    this.setState(
      {
        searchKeyword: '',
        componentFileList: [],
        activeIndex: [],
      },
      () => {
        this.getComponentfileList();
      }
    );
  };

  clearCustomApply = () => {
    const { state } = this.props;
    this.setState({
      componentFileList: [],
      activeIndex: [],
      customComponent: null,
    }, () => {
      state.report.initSearchKeyword();
      this.getComponentfileList();
    });
  };

  updateDefinedFilter = (searchValue) => {
    const { state } = this.props;
    this.setState({
      searchKeyword: '',
      customComponent: searchValue,
      componentFileList: [],
      activeIndex: [],
    }, () => {
      state.report.initSearchKeyword();
    });
  };

  renderValue = () => {
    const { t } = this.props;
    const { filter, customComponent } = this.state;

    const securityFilter = filter.filter((item) => {
      return item.indexOf('security') > -1;
    });

    const licenseFilter = filter.filter((item) => {
      return item.indexOf('license') > -1;
    });

    const litigatorFilter = filter.filter((item) => {
      return item.indexOf('litigator') > -1;
    });

    const filterObj = {
      security: securityFilter,
      license: licenseFilter,
      litigator: litigatorFilter,
      customComponent,
    };

    return (
      <div>
        {filterObj.customComponent && (
          <Label.Group>
            <span>
              <strong>{t('list.title.component')}</strong>
            </span>
            <Label>
              {customComponent}
              <Icon
                name="close"
                onClick={() => {
                  return this.clearCustomApply();
                }}
              />
            </Label>
          </Label.Group>
        )}
        {filterObj.security.length !== 0 && (
          <Label.Group>
            <span>
              <strong>{t('contents_header.menu.security')}</strong>
            </span>
            {filterObj.security.map((item) => {
              return (
                <Label as="a" key={uuidv4()}>
                  {item.indexOf('_c') > -1 && t('contents_header.menu.critical')}
                  {item.indexOf('_h') > -1 && t('contents_header.menu.high')}
                  {item.indexOf('_m') > -1 && t('contents_header.menu.medium')}
                  {item.indexOf('_l') > -1 && t('contents_header.menu.low')}
                  <Icon
                    name="close"
                    onClick={() => {
                      return this.clearValue(item.toString());
                    }}
                  />
                </Label>
              );
            })}
          </Label.Group>
        )}

        {filterObj.license.length !== 0 && (
          <Label.Group>
            <span>
              <strong>{t('contents_header.menu.license')}</strong>
            </span>
            {filterObj.license.map((item) => {
              return (
                <Label as="a" key={uuidv4()}>
                  {item.indexOf('_pt') > -1 && t('contents_header.menu.protective')}
                  {item.indexOf('_pm') > -1 && t('contents_header.menu.permissive')}
                  {item.indexOf('_o') > -1 && t('contents_header.menu.others')}
                  <Icon
                    name="close"
                    onClick={() => {
                      return this.clearValue(item.toString());
                    }}
                  />
                </Label>
              );
            })}
          </Label.Group>
        )}

        {filterObj.litigator.length !== 0 && (
          <Label.Group>
            <span>
              <strong>{t('contents_header.menu.litigator')}</strong>
            </span>
            {filterObj.litigator.map((item) => {
              return (
                <Label as="a" key={uuidv4()}>
                  {item.indexOf('_mc') > -1 && t('contents_header.menu.mchardy')}
                  {item.indexOf('_sf') > -1 && t('contents_header.menu.sfc')}
                  {item.indexOf('_pt') > -1 && t('contents_header.menu.patent')}
                  <Icon
                    name="close"
                    onClick={() => {
                      return this.clearValue(item.toString());
                    }}
                  />
                </Label>
              );
            })}
          </Label.Group>
        )}

        {filter.length !== 0 ? (
          <div
            className="clear_all"
            onClick={() => {
              return this.clearAllValue();
            }}
            onKeyUp={() => {
              return this.clearAllValue();
            }}
          >
            {t('project.menu.clear_all_filters')}
          </div>
        ) : null}
      </div>
    );
  };

  renderChartLabel = (obj) => {
    const { t } = this.props;
    const { languages } = obj;
    let count = 0;

    if (languages.length > 3) {
      let i = 0;
      for (i; i < languages.length; i++) {
        if (i > 2) {
          count += languages[i].percentage;
        }
      }
    }

    if (languages.length !== 0) {
      return languages.map((item, index) => {
        if (index < 4) {
          return (
            <dl className="" key={item.language.toString()}>
              <dt>
                <Label
                  circular
                  className={cx({
                    first: index === 0,
                    second: index === 1,
                    third: index === 2,
                    fourth: index === 3,
                  })}
                />
                {
                  index === 3 ? t('contents_header.menu.others') : item.language
                }
              </dt>
              <dd>
                {
                  index === 3 ? Math.round(count * 100) / 100 : Math.round(item.percentage * 100) / 100
                }
                %
              </dd>
            </dl>
          );
        }
        return null;
      });
    }
    return null;
  };

  render() {
    const {
      error,
      hasMore,
      isLoading,
      componentFileList,
      activeIndex,
      filter,
      sortValue,
      isSort,
      isDetailLoading,
      isVisible,
      infoPopupIndex,
      popupType,
      viewMode,
      pageSize,
      currentPage,
      totalPage,
      activePage,
      pdfElement,
      isOpenMEC,
      isLoaderMEC,
      componentList,
      sumData,
      searchKeyword,
      customComponent,
      totalCount,
      idReport,
      isOpenMFD,
      currentComponentName,
      commentList,
      isRenderListOnly,
      isOpenWarnModal,
      componentVersionType,
      currentComponentVersion,
      componentName,
      isOpenCVM,
    } = this.state;

    const {
      location, state, params, t, navigate
    } = this.props;

    return (
      <div
        className="result_file"
        ref={this.componentDetail}
      >
        <ContentsHeaderWithResultAll
          onChangeSearch={this.handleChange}
          onSubmit={this.handleFilterData}
          clearSearch={this.clearSearch}
          filter={filter}
          handlePrecisionLevel={this.setPrecisionLevel}
          viewMode={viewMode}
          pageSize={pageSize}
          handlePageSizeChange={this.handlePageSizeChange}
          toggleViewMode={this.toggleViewMode}
          refElement={pdfElement}
          currentPage={currentPage}
          isRenderListOnly={isRenderListOnly}
          createElementWithCanvas={this.createElementWithCanvas}
          generatePdfCallback={this.generatePdfCallback}
          handleSearchChange={this.handleSearchChange}
          location={location}
          state={state}
          params={params}
          translate={t}
          navigate={navigate}
          searchKeyword={searchKeyword}
          totalCount={totalCount}
        />
        <div className="content">
          {filter.length !== 0 || customComponent ? <div className="tag_list">{this.renderValue()}</div> : ''}
          <div className="content_projects_List">
            <div className="wide_card_wrap">
              <div className="table_header">
                <div className="table_header_inner">
                  <table className="wide_card_table wide_card_scope">
                    <colgroup>
                      <col style={{ width: '3.9%', maxWidth: '36px' }} />
                      <col style={{ width: '22.1%', maxWidth: '200px' }} />
                      <col style={{ width: '12%' }} />
                      <col style={{ width: '12%' }} />
                      <col style={{ width: '45.7%' }} />
                      <col style={{ width: '4.3%', maxWidth: '40px' }} />
                    </colgroup>
                    <tbody>
                      <tr>
                        <th className="checkbox_wrap tal">
                          <div className="checkbox" />
                        </th>
                        <th className="tal">
                          <a
                            className="sorting_button"
                            data-id="1"
                            onClick={this.onChangeSorting}
                            onKeyUp={this.onChangeSorting}
                          >
                            {t('list.title.component')}
                            {isSort && sortValue === '1' ? <img src={upIcon} alt="" /> : ''}
                            {!isSort && sortValue === '1' ? <img src={downIcon} alt="" /> : ''}
                          </a>
                        </th>
                        <th className="tac">
                          <a
                            className="sorting_button"
                            data-id="2"
                            onClick={this.onChangeSorting}
                            onKeyUp={this.onChangeSorting}
                          >
                            {t('list.title.component_version')}
                            {isSort && sortValue === '2' ? <img src={upIcon} alt="" /> : ''}
                            {!isSort && sortValue === '2' ? <img src={downIcon} alt="" /> : ''}
                          </a>
                        </th>
                        <th className="tac">
                          <a
                            className="sorting_button"
                            data-id="3"
                            onClick={this.onChangeSorting}
                            onKeyUp={this.onChangeSorting}
                          >
                            {t('list.title.scanned_file')}
                            {isSort && sortValue === '3' ? <img src={upIcon} alt="" /> : ''}
                            {!isSort && sortValue === '3' ? <img src={downIcon} alt="" /> : ''}
                          </a>
                        </th>
                        <th className="sum_th">
                          <table>
                            <colgroup>
                              <col style={{ width: '41.4%' }} />
                              <col style={{ width: '34.3%' }} />
                              <col style={{ width: '12%' }} />
                              <col style={{ width: '' }} />
                            </colgroup>
                            <tbody>
                              <tr>
                                <th className="tac">
                                  <a
                                    className="sorting_button"
                                    data-id="4"
                                    onClick={this.onChangeSorting}
                                    onKeyUp={this.onChangeSorting}
                                  >
                                    {t('list.title.security_risk')}
                                    {isSort && sortValue === '4' ? <img src={upIcon} alt="" /> : ''}
                                    {!isSort && sortValue === '4' ? <img src={downIcon} alt="" /> : ''}
                                  </a>
                                </th>
                                <th className="tac">
                                  <a
                                    className="sorting_button"
                                    data-id="5"
                                    onClick={this.onChangeSorting}
                                    onKeyUp={this.onChangeSorting}
                                  >
                                    {t('list.title.license')}
                                    {isSort && sortValue === '5' ? <img src={upIcon} alt="" /> : ''}
                                    {!isSort && sortValue === '5' ? <img src={downIcon} alt="" /> : ''}
                                  </a>
                                </th>
                                <th className="tac">
                                  <a
                                    className="sorting_button"
                                    data-id="6"
                                    onClick={this.onChangeSorting}
                                    onKeyUp={this.onChangeSorting}
                                  >
                                    {t('list.title.title_license')}
                                    {isSort && sortValue === '6' ? <img src={upIcon} alt="" /> : ''}
                                    {!isSort && sortValue === '6' ? <img src={downIcon} alt="" /> : ''}
                                  </a>
                                </th>
                                <th className="tac">
                                  <a
                                    className="sorting_button"
                                    data-id="7"
                                    onClick={this.onChangeSorting}
                                    onKeyUp={this.onChangeSorting}
                                  >
                                    {t('list.title.litigator')}
                                    {isSort && sortValue === '7' ? <img src={upIcon} alt="" /> : ''}
                                    {!isSort && sortValue === '7' ? <img src={downIcon} alt="" /> : ''}
                                  </a>
                                </th>
                              </tr>
                            </tbody>
                          </table>
                        </th>
                        <th>&nbsp;</th>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              {componentFileList.map((item, index) => {
                return (
                  <div
                    className={cx(
                      'wide_card_box wide_card_type_02',
                      {
                        expand: activeIndex.indexOf(index) >= 0,
                      },
                      {
                        card_detail_popup_show: infoPopupIndex.indexOf(index) >= 0,
                      },
                    )}
                    key={item.componentName.toString()}
                  >
                    <table className="wide_card_table wide_card_item">
                      <colgroup>
                        <col style={{ width: '3.9%', maxWidth: '36px' }} />
                        <col style={{ width: '22.1%', maxWidth: '204px' }} />
                        <col style={{ width: '61.1%' }} />
                        <col style={{ width: '4.3%', maxWidth: '40px' }} />
                      </colgroup>
                      <tbody>
                        <tr
                          className="sum_line"
                          onClick={() => {
                            return this.toggleRow(index, item.componentName);
                          }}
                        >
                          <td className="checkbox_wrap border-none tal">
                            <div className="checkbox" />
                          </td>
                          <td
                            className="border-none tal"
                            style={{
                              maxWidth: '204px',
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                              whiteSpace: 'nowrap',
                            }}
                          >
                            <strong>{item.componentName}</strong>
                          </td>
                          <td className="tal sum_td" colSpan="3">
                            <table className="wide_card_table wide_card_item">
                              <colgroup>
                                <col style={{ width: '17.2%' }} />
                                <col style={{ width: '17.2%' }} />
                                <col style={{ width: '65.5%' }} />
                              </colgroup>
                              <tbody>
                                <tr className="">
                                  <td className="tac" style={{ paddingLeft: '7px' }}>
                                    {item.componentVersionCount}
                                  </td>
                                  <td className="tac">{item.scannedFileCount}</td>
                                  <td className="sum_td tac">
                                    <table className="sub_table">
                                      <colgroup>
                                        <col style={{ width: '41.4%' }} />
                                        <col style={{ width: '34.3%' }} />
                                        <col style={{ width: '12%' }} />
                                        <col style={{ width: '' }} />
                                      </colgroup>
                                      <tbody>
                                        <tr>
                                          <td className="tac">
                                            <div className="belt_chart">
                                              <div className="red">
                                                {item.securityCount.critical}
                                              </div>
                                              <div className="orange">
                                                {item.securityCount.high}
                                              </div>
                                              <div className="cheese">
                                                {item.securityCount.medium}
                                              </div>
                                              <div className="yellow">{item.securityCount.low}</div>
                                            </div>
                                            {
                                              item.hasExploit ? (<Icon name="bug" />) : null
                                            }
                                          </td>
                                          <td className="tac">
                                            <div className="belt_chart round">
                                              <div className="red">
                                                {item.licenseCount.protective}
                                              </div>
                                              <div className="cheese">
                                                {item.licenseCount.permissive}
                                              </div>
                                              <div className="yellow">
                                                {item.licenseCount.others}
                                              </div>
                                            </div>
                                          </td>
                                          <TextWithEllipsis className="tac" as="td" text={item.titleLicense} />
                                          <TextWithEllipsis className="tac" as="td" text={item.litigatorString} />
                                        </tr>
                                      </tbody>
                                    </table>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </td>
                          <td className="border-none tac">
                            <a
                              className="expand_button"
                            >
                              <img src={expandBtn} alt="" />
                            </a>
                          </td>
                        </tr>
                        {
                          isDetailLoading && isVisible === item.componentName ? (
                            <tr>
                              <td className="border-none" colSpan="6">
                                <div style={{ position: 'absolute', top: '50%', left: '50%' }}>
                                  <Loader active={isDetailLoading && isVisible === item.componentName} inline="centered" />
                                </div>
                              </td>
                            </tr>
                          ) : (
                            <tr className="extend_item">
                              <td className="border-none">&nbsp;</td>
                              <td className="border-none tal">&nbsp;</td>
                              <td className="tal border-none sum_td" colSpan="3">
                                {
                                  item.componentList
                                  && (
                                    <ComponentRow
                                      childRef={this.viewRef}
                                      parentRowData={item.componentList}
                                      uid={item.uploadedFileId}
                                      t={t}
                                      state={state}
                                      location={location}
                                      params={params}
                                    />
                                  )
                                }
                              </td>
                              <td className="border-none">&nbsp;</td>
                            </tr>
                          )
                        }

                      </tbody>
                    </table>
                    {item.componentList ? (
                      <div className="wide_card_detail">
                        <div className="wide_card_detail_top component">
                          <p className="title">{t('list.title.written_in')}</p>
                          <PieChart chartData={item.componentList} currentIndex={index} activeIndex={activeIndex} translate={t} />
                          {this.renderChartLabel(item.componentList)}
                        </div>
                        <div className="wide_card_detail_bottom">
                          <a
                            className={cx('card_detail_popup_show', {
                              active: infoPopupIndex.indexOf(index) >= 0 && popupType === 'type_0',
                            })}
                            style={{ cursor: 'pointer' }}
                            onClick={() => {
                              return this.handleMoreInfo(index, 'type_0');
                            }}
                            onKeyUp={() => {
                              return this.handleMoreInfo(index, 'type_0');
                            }}
                          >
                            {t('list.title.more_information')}
                          </a>
                          <div className="bottom_button_wrap flex">
                            {
                              item.componentList.has_manage_permission ? (
                                <a
                                  className="card_detail_popup_show left_button"
                                  style={{ cursor: 'pointer' }}
                                  onClick={() => {
                                    return this.getComponentEdit(item.uploadedFileId, item.componentList.component_name);
                                  }}
                                  onKeyUp={() => {
                                    return this.getComponentEdit(item.uploadedFileId, item.componentList.component_name);
                                  }}
                                >
                                  <Icon name="edit" />
                                  <span>{t('list.title.edit_component')}</span>
                                </a>
                              ) : (
                                <a
                                  className="card_detail_popup_show left_button"
                                  style={{ pointerEvents: 'none', cursor: 'default', opacity: '.45' }}
                                >
                                  <Icon name="edit" />
                                  <span>{t('list.title.edit_component')}</span>
                                </a>
                              )
                            }
                            <a
                              className="right_button"
                              style={{ cursor: 'pointer' }}
                              onClick={() => {
                                return this.handleMFDOpen(item.componentName, item.componentList.more_info.comment);
                              }}
                              onKeyUp={() => {
                                return this.handleMFDOpen(item.componentName, item.componentList.more_info.comment);
                              }}
                            >
                              <Icon name="comments outline" />
                              <span>{t('modal.title.comment_show')}</span>
                            </a>
                          </div>
                          {
                            item.componentList.last_version ? (
                              <a
                                className="card_detail_popup_show"
                                style={{ cursor: 'pointer' }}
                                onClick={() => { return this.handleCompareAllVersion(item.componentName); }}
                                onKeyUp={() => { return this.handleCompareAllVersion(item.componentName); }}
                              >
                                <img src={compareBtn} alt="" style={{ width: '15px', verticalAlign: 'sub', marginRight: '3px' }} />
                                <span>{t('list.title.compare_all_versions')}</span>
                              </a>
                            ) : (
                              <a
                                className="card_detail_popup_show"
                                style={{ pointerEvents: 'none', cursor: 'default', opacity: '.45' }}
                              >
                                <img src={compareBtn} alt="" style={{ width: '15px', verticalAlign: 'sub', marginRight: '3px' }} />
                                <span>{t('list.title.compare_all_versions')}</span>
                              </a>
                            )
                          }
                          {
                            item.componentList.last_version ? (
                              <a
                                className="card_detail_popup_show"
                                data-type="0"
                                style={{ cursor: 'auto' }}
                              >
                                {t('list.title.lates_version')}
                                (
                                {item.componentList.last_version}
                                )
                              </a>
                            ) : null
                          }
                        </div>
                      </div>
                    ) : null}
                    {item.componentList ? (
                      <div
                        className={cx('card_detail_popup card_detail_popup_1', {
                          show: infoPopupIndex.indexOf(index) >= 0 && popupType === 'type_0',
                        })}
                      >
                        <div className="popup_box">
                          <h3 className="popup_header">
                            {t('list.title.more_information')}
                            <a
                              className="card_detail_popup_hide"
                              style={{ cursor: 'pointer' }}
                              onClick={() => {
                                return this.handleMoreInfoClose(index);
                              }}
                              onKeyUp={() => {
                                return this.handleMoreInfoClose(index);
                              }}
                            >
                              <img src={closeBtn} alt="" />
                            </a>
                          </h3>
                          <div className="popup_content">
                            <Scrollbars
                              renderTrackHorizontal={() => {
                                return <div />;
                              }}
                              renderThumbHorizontal={() => {
                                return <div />;
                              }}
                            >
                              <div className="type_3">
                                <dl>
                                  <dt>{t('list.title.group_id')}</dt>
                                  <dd className="text_ellipsis">{item.componentList.more_info.group_id}</dd>
                                </dl>
                                <dl>
                                  <dt>{t('list.title.artifact_id')}</dt>
                                  <dd>{item.componentList.more_info.artifact_id}</dd>
                                </dl>
                                {item.componentList.more_info && item.componentList.more_info.url && (
                                  <div>
                                    <div className="line" />
                                    {
                                      item.componentList.more_info.url.homepage
                                      && (
                                        <dl>
                                          <dt>{t('modal.component_detail.homepage')}</dt>
                                          <dd>
                                            <em>{item.componentList.more_info.url.homepage}</em>
                                          </dd>
                                        </dl>
                                      )
                                    }
                                    {
                                      item.componentList.more_info.url.download
                                      && (
                                        <dl>
                                          <dt>{t('list.title.origin_list')}</dt>
                                          {
                                            item.componentList.more_info.url.download.map((url) => {
                                              return (
                                                <dd key={uuidv4()}>
                                                  <em>{url}</em>
                                                </dd>
                                              );
                                            })
                                          }
                                        </dl>
                                      )
                                    }
                                  </div>
                                )}
                              </div>
                            </Scrollbars>
                          </div>
                        </div>
                      </div>
                    ) : null}
                  </div>
                );
              })}
              {error && <div className="error_log">{error}</div>}
              {isLoading && (
                <Segment>
                  <Dimmer active inverted>
                    <Loader size="medium" style={{ lineHeight: '15px' }}>{t('modal.message.loading')}</Loader>
                  </Dimmer>
                </Segment>
              )}
              {
                viewMode === 'list' && componentFileList.length !== 0
                && (
                  <div className="clar_pagination" style={{ marginTop: '10px', textAlign: 'center' }}>
                    <Pagination
                      activePage={currentPage}
                      totalPages={totalPage}
                      onPageChange={this.handlePaginationChange}
                      ellipsisItem={{ content: <Icon name="ellipsis horizontal" />, icon: true }}
                      firstItem={currentPage !== 1 ? { content: <Icon name="angle double left" />, icon: true } : null}
                      lastItem={currentPage !== totalPage ? { content: <Icon name="angle double right" />, icon: true } : null}
                      prevItem={currentPage > 1 ? { content: <Icon name="angle left" />, icon: true } : null}
                      nextItem={currentPage < totalPage ? { content: <Icon name="angle right" />, icon: true } : null}
                    />
                    <div className="active_page">
                      <Input
                        type="number"
                        label={t('list.title.active_page')}
                        min={1}
                        value={activePage}
                        onChange={this.handleInputActivePageChange}
                        onKeyPress={this.handleActivePageChange}
                      />
                    </div>
                  </div>
                )
              }
              {!hasMore && <Footer />}
            </div>
          </div>
        </div>
        <ComponentVersionModal
          isOpenCVM={isOpenCVM}
          closeModal={this.handleCVMClose}
          idReport={idReport}
          componentName={componentName}
          currentComponentVersion={currentComponentVersion}
          componentVersionType={componentVersionType}
          translate={t}
        />
        <EditComponentModal
          isOpenMEC={isOpenMEC}
          isLoaderMEC={isLoaderMEC}
          componentList={componentList}
          sumData={sumData}
          closeModal={this.handleMECClose}
          handleSaveCallback={this.handleSaveCallback}
          handleModalLoader={this.handleModalLoader}
          location={location}
          translate={t}
        />
        <FeedModal
          isOpenMFD={isOpenMFD}
          uploadedFileId={idReport}
          currentComponentName={currentComponentName}
          commentList={commentList}
          closeModal={this.closeMFDModal}
          translate={t}
        />
        <Modal open={isOpenWarnModal} onClose={this.closeModal}>
          <div className="modal_popup_wrap">
            <div className="modal_popup_box">
              <div className="modal_popup">
                <h2 className="title">{this.modalAction}</h2>
                <p className="text">{this.modalBody}</p>
                {
                  this.smallBody
                  && <p className="small_text">{this.smallBody}</p>
                }
                <div className="button_wrap">
                  <a
                    className="center_button"
                    style={{ cursor: 'pointer' }}
                    onClick={this.closeModal}
                    onKeyUp={this.closeModal}
                  >
                    {t('modal.button.ok')}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}

export default WithRouter(withTranslation()(inject('state')(observer(ComponentDetail))));
